<!--
  OrgVouchers — 기관 관리 › 바우처관리 (기관 Master 전용)
  · 탭: 현황(summary·클래스별 통계) / 도서 지정 / 충전·내역(purchases·ledger) / 등록 내역(vouchers)
  · 탭은 ?tab= 으로 유지. 강사별 클래스 목록의 ‘도서 지정’ 은 ?tab=assign&classroom_idx= 로 들어온다
  정본: docs/바우처_기관발행_강사화면.md §3.3·§4.2
-->
<template>
  <div class="p-page">
    <a-page-head title="바우처관리" :breadcrumbs="[{ label: '기관 관리' }, { label: '바우처관리' }]">
      <template #actions>
        <a-btn kind="ghost" size="md" @click="reloadKey++">새로고침</a-btn>
      </template>
    </a-page-head>

    <org-selector />

    <a-card bare padding="8" class="p-tabbar">
      <div class="p-tabs">
        <button
          v-for="t in tabs"
          :key="t.key"
          class="p-tab"
          :class="{ 'is-active': activeTab === t.key }"
          @click="setTab(t.key)"
        >{{ t.label }}</button>
      </div>
    </a-card>

    <template v-if="orgIdx">
      <voucher-summary-tab
        v-if="activeTab === 'summary'"
        :key="`s-${orgIdx}-${reloadKey}`"
        :org-idx="orgIdx"
        @go-tab="setTab"
      />
      <voucher-assign-tab
        v-else-if="activeTab === 'assign'"
        :key="`a-${orgIdx}-${reloadKey}`"
        :org-idx="orgIdx"
        :currency="currency"
        :initial-classroom-idx="initialClassroomIdx"
      />
      <voucher-purchase-tab
        v-else-if="activeTab === 'purchase'"
        :key="`p-${orgIdx}-${reloadKey}`"
        :org-idx="orgIdx"
        :organization="organization"
      />
      <voucher-registrations-tab
        v-else-if="activeTab === 'registrations'"
        :key="`r-${orgIdx}-${reloadKey}`"
        :org-idx="orgIdx"
      />
    </template>
    <a-empty v-else title="기관 정보를 불러오는 중입니다" />
  </div>
</template>

<script>
import APageHead from '@/components/Pineapple/APageHead.vue';
import ACard from '@/components/Pineapple/ACard.vue';
import ABtn from '@/components/Pineapple/ABtn.vue';
import AEmpty from '@/components/Pineapple/AEmpty.vue';
import OrgSelector from './components/OrgSelector.vue';
import VoucherSummaryTab from './components/VoucherSummaryTab.vue';
import VoucherAssignTab from './components/VoucherAssignTab.vue';
import VoucherPurchaseTab from './components/VoucherPurchaseTab.vue';
import VoucherRegistrationsTab from './components/VoucherRegistrationsTab.vue';

const TABS = [
  { key: 'summary',       label: '현황' },
  { key: 'assign',        label: '도서 지정' },
  { key: 'purchase',      label: '충전·내역' },
  { key: 'registrations', label: '등록 내역' },
];

export default {
  name: 'OrgVouchers',
  components: { APageHead, ACard, ABtn, AEmpty, OrgSelector, VoucherSummaryTab, VoucherAssignTab, VoucherPurchaseTab, VoucherRegistrationsTab },
  data() {
    return { tabs: TABS, reloadKey: 0 };
  },
  computed: {
    orgIdx() { return this.$store.getters['organization/currentIdx']; },
    organization() { return this.$store.getters['organization/current']; },
    currency() { return this.organization ? this.organization.voucher_currency || '' : ''; },
    activeTab() {
      const t = this.$route.query.tab;
      return TABS.some(x => x.key === t) ? t : 'summary';
    },
    initialClassroomIdx() {
      const v = this.$route.query.classroom_idx;
      return v ? Number(v) : null;
    },
  },
  methods: {
    setTab(key) {
      const query = { ...this.$route.query, tab: key };
      if (key !== 'assign') delete query.classroom_idx;
      this.$router.replace({ query });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './_org.scss';
</style>
